import request from '@/utils/request'

// 查询历史搜索列表分页
export function fetchList(query) {
    return request({
        url: '/upkeep/prod/sku/svc/page',
        method: 'get',
        params: query,
    })
}
// 查询历史搜索详细
export function getObj(data) {
    return request({
        url: '/upkeep/prod/sku/svc/detail?prodSkuId=' + data.prodSkuId + '&serviceItemId=' + data.serviceItemId,
        method: 'get',
    })
}
// 新增历史搜索
export function addObj(data) {
    return request({
        url: '/upkeep/prod/sku/svc/add',
        method: 'post',
        data: data,
    })
}
// 修改历史搜索
export function putObj(data) {
    return request({
        url: '/upkeep/prod/sku/svc/edit',
        method: 'post',
        data: data,
    })
}
// 删除历史搜索
export function delObj(data) {
    return request({
        url: '/upkeep/prod/sku/svc/delete',
        method: 'post',
        data: data,
    })
}

export function statusObj(data){
    return request({
        url: '/upkeep/prod/sku/svc/status',
        method: 'post',
        data: data,
    })
}
